// KPI card grid — 8 metrics at the top of Mission Control.
import {
  Users, TrendingUp, Phone, DollarSign, CheckCircle2, Send, Plug, Webhook,
} from "lucide-react";
import { RED, NEON, AMBER, fmt$ } from "./shared";

export function KPICards({ overview }) {
  const items = [
    { k: "leads_today",         t: "LEADS TODAY",  Icon: Users,        val: overview?.leads_today ?? "—",       accent: RED },
    { k: "leads_total",         t: "LEADS TOTAL",  Icon: TrendingUp,   val: overview?.leads_total ?? "—",       accent: "white" },
    { k: "call_queue",          t: "CALL QUEUE",   Icon: Phone,        val: overview?.call_queue ?? "—",        accent: AMBER },
    { k: "revenue_mtd",         t: "REVENUE MTD",  Icon: DollarSign,   val: fmt$(overview?.revenue_mtd_cents),  accent: NEON },
    { k: "assessments_total",   t: "ASSESSMENTS",  Icon: CheckCircle2, val: overview?.assessments_total ?? "—", accent: "white" },
    { k: "shipments_total",     t: "SHIPMENTS",    Icon: Send,         val: overview?.shipments_total ?? "—",   accent: "white" },
    { k: "integrations_active", t: "INTEGRATIONS", Icon: Plug,         val: overview?.integrations_active ?? "—", accent: NEON },
    { k: "webhooks_active",     t: "WEBHOOKS",     Icon: Webhook,      val: overview?.webhooks_active ?? "—",   accent: NEON },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-3 mb-5" data-testid="kpi-grid">
      {items.map(({ k, t, Icon, val, accent }) => (
        <div key={k} className="rounded-sm border border-white/10 bg-black/50 px-4 py-3 min-w-0" data-testid={`kpi-${k}`}>
          <div className="flex items-center justify-between mb-2">
            <Icon size={14} className="text-white/50" />
            <span className="text-[9.5px] tracking-[0.16em] font-bold text-white/45 truncate">{t}</span>
          </div>
          <p className="font-heavy leading-none truncate" style={{ color: accent, fontSize: "26px" }}>{val}</p>
        </div>
      ))}
    </div>
  );
}
